export default function FooterAdmin() {
  return (
    <footer className="block py-4 footer-center">
      <div className="container mx-auto px-4">
        <hr className="mb-4 border-b-1 border-slate-200" />
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full md:w-4/12 px-4">
            <div className="text-sm text-slate-500 font-semibold py-1 text-center md:text-left">
              Copyright © {new Date().getFullYear()}{" "}
              <a className="text-slate-500 hover:text-slate-700 text-sm font-semibold py-1">
                Mecanica MX
              </a>
            </div>
          </div>
          <div className="w-full md:w-8/12 px-4">
            <ul className="flex flex-wrap list-none md:justify-end  justify-center">
              <li>
                <a
                  href="https://mecanica.mx"
                  target="_blank"
                  className="text-slate-500 hover:text-slate-700 text-sm font-semibold block py-1 px-3"
                >
                  Mecanica MX
                </a>
              </li>
              <li>
                <a
                  href="https://mecanica.mx"
                  target="_blank"
                  className="text-slate-500 hover:text-slate-700 text-sm font-semibold block py-1 px-3"
                >
                  Acerca de
                </a>
              </li>
              <li>
                <a
                  href="https://blog.mecanica.mx"
                  target="_blank"
                  className="text-slate-500 hover:text-slate-700 text-sm font-semibold block py-1 px-3"
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer >
  );
}
